/** @format */

export const BG_COLORS = {
  GREEN: "green",
  GRAY: "gray",
};

export const STATUSES = {
  PUBLISHED: "Published",
  DRAFT: "Draft",
  FEATURED: "Featured",
};

export const STATUSES_UP = {
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  FEATURED: "FEATURED",
};

export const IS_PUBLISHED = {
  PUBLISHED: "Published",
  UNPUBLISHED: "Unpublished",
};

export const EMPLOYEMENT_TYPE = {
  FULL_TIME: "Full time",
  PART_TIME: "Part time",
};

export const EMPLOYEMENT_TYPE_UP = {
  FULL_TIME: "FULL_TIME",
  PART_TIME: "PART_TIME",
};

export const ACCOUNT_TYPES = {
  COMPANY: "Company",
  CREATIVE: "Creative",
  ADMINISTRATOR: "Administrator",
  CONTENT_MANAGER: "Content Manager",
};

export const ACCOUNT_TYPES_UP = {
  COMPANY: "COMPANY",
  CREATIVE: "CREATIVE",
  ADMINISTRATOR: "ADMINISTRATOR",
  CONTENT_MANAGER: "CONTENT_MANAGER",
};

export const SORT_BY_TYPES = {
  DATE: "Created date",
  NUMBER: "Number of projects",
};

export const SORT_BY_TYPES_UP = {
  DATE: "CREATED_AT",
  NUMBER: "PROJECT_NUMBER",
};
